/**
 * The three views of one meter, in the order the page shows them.
 *
 * The page returns early when no KPI is mapped for the year, so every card
 * listed here can build a request and report a narrative back. That is what
 * lets the summary below wait on this count: a card that could never report
 * would leave it waiting for a narrative that is never coming.
 */
export const DETAIL_GRAPHS = [
  {
    graphType: 'netConsumption',
    title: 'Net Consumption',
    description: 'One bar per day. The current day is still filling.',
    aggregationPeriod: 'day',
    timeRangePeriod: 'week',
  },
  {
    graphType: 'massTotalizer',
    title: 'Volume Totalizer',
    description:
      'A running counter — it holds, then jumps. Each flow is scaled to its own axis, so their heights are not comparable.',
    autoRefresh: true,
  },
  {
    graphType: 'instantaneousFlow',
    title: 'Instantaneous Flow',
    description: 'Rate at a moment. Gaps are left open, not joined up.',
    autoRefresh: true,
  },
];
